export default "/images/b_rank.webp?f6a3923827c1cfb2c0c81ed8879bf4b7";